module.exports = __webpack_public_path__ + "img/20250528_Goetz_Siegel_1000.8c05cb23.jpg";